export const SET_SECTION_LIST = 'set-section-list';
export const SET_TABLE_ORDER_DETAILS = 'set_table_order_details';
